// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1gJVP","title":"Header_title__Os65m","left":"Header_left__3ULwI","clinicName":"Header_clinicName__2RWVm"};